import { render } from "./CZUKElectricityGeneration.vue?vue&type=template&id=f3997d16&ts=true"
import script from "./CZUKElectricityGeneration.vue?vue&type=script&lang=ts"
export * from "./CZUKElectricityGeneration.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Develop\\Czone_UI_EIC\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__